"use es6";

export function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}